import {
    FETCH_GROUP,
    FETCH_GROUP_SUCCESS,
    FETCH_GROUP_FAIL,
    RESET_GROUP_PAGE,
    SET_GROUP_PAGE_TAB,
    SET_GROUP_PAGE_FEED_TAB,
    SAVE_GROUP_ANNOUNCEMENT,
    SAVE_GROUP_ANNOUNCEMENT_SUCCESS,
    SAVE_GROUP_ANNOUNCEMENT_FAILED,
    SAVE_GROUP_POST,
    SAVE_GROUP_POST_SUCCESS,
    DELETE_GROUP_ANNOUNCEMENT,
    DELETE_GROUP_ANNOUNCEMENT_SUCCESS,
    DELETE_GROUP_ANNOUNCEMENT_FAILED,
    FETCH_GROUP_POSTS,
    FETCH_GROUP_POST,
    FETCH_GROUP_POSTS_SUCCESS,
    FETCH_GROUP_POSTS_FAILED,
    FETCH_GROUP_COMMENTS,
    SAVE_GROUP_POST_FAILED,
    FETCH_GROUP_COMMENTS_SUCCESS,
    FETCH_GROUP_COMMENTS_FAILED,
    SAVE_GROUP_COMMENT,
    SAVE_GROUP_COMMENT_SUCCESS,
    SAVE_GROUP_COMMENT_FAILED,
    EDIT_GROUP_COMMENT,
    DELETE_GROUP_POST,
    DELETE_GROUP_POST_SUCCESS,
    DELETE_GROUP_POST_FAILED,
    DELETE_GROUP_COMMENT,
    DELETE_GROUP_COMMENT_SUCCESS,
    DELETE_GROUP_COMMENT_FAILED,
    OPEN_DELETE_CONFIRM_DIALOG,
    CLOSE_DELETE_CONFIRM_DIALOG,
    CONFIRM_DELETE_CONFIRM_DIALOG,
    UPDATE_GROUP_CONVERSATION_LIKE,
    UPDATE_GROUP_CONVERSATION_LIKE_START,
    UPDATE_GROUP_CONVERSATION_LIKE_DONE,
    FETCH_GROUP_CONVERSATION_LIKERS,
    FETCH_GROUP_COMMENT_LIKERS,
    FETCH_GROUP_COMMENT_LIKERS_DONE,
    FETCH_GROUP_CONVERSATION_LIKERS_DONE,
    UPDATE_GROUP_COMMENT_LIKE,
    UPDATE_GROUP_COMMENT_LIKE_START,
    UPDATE_GROUP_COMMENT_LIKE_DONE,
    CONFIRM_LEAVE_GROUP,
    SET_GROUP_LEADERBOARD_TYPE,
    FETCH_GROUP_LEADERBOARD,
    FETCH_GROUP_LEADERBOARD_FAILED,
    FETCH_GROUP_LEADERBOARD_SUCCESS,
    SET_GROUP_LEADERBOARD_VIEW_PREVIOUS,
    INIT_GROUP_LEADERBOARD,
    FETCH_GROUP_ALL_FEEDS,
    FETCH_GROUP_ACTIVITY_FEEDS,
    FETCH_GROUP_ACTIVITY_FEEDS_SUCCESS,
    FETCH_GROUP_ACTIVITY_FEEDS_FAILED,
    FETCH_GROUP_ACTIVITY_FEED,
    GROUP_PAGE_JOIN_GROUP,
    GROUP_PAGE_REQUEST_JOIN_GROUP,
    GROUP_PAGE_CANCEL_REQUEST_JOIN_GROUP,
    GROUP_PAGE_ACCEPT_INVITATION,
    GROUP_PAGE_SEARCH_USER,
    GROUP_PAGE_SEARCH_USER_DONE,
    UPDATE_GROUP_MEMBERS,
    SORT_GROUP_MEMBERS,
    UPDATE_GROUP_INVITES,
    GROUP_PAGE_UNBLOCK_USER,
    GROUP_PAGE_UNBLOCK_USER_DONE,
    UPDATE_GROUP_USER_CONNECTIONS,
    UPDATE_GROUP_USER_CONNECTION,
    GROUP_PAGE_CANCEL_INVITE_USER,
    GROUP_PAGE_INVITE_USER,
    UPDATE_GROUP_SEARCH_USER_CONNECTION_STATUS,
    GROUP_PAGE_CANCEL_INVITE_USER_DONE,
    GROUP_PAGE_INVITE_USER_DONE,
    UPDATE_GROUP_MEMBER_REQUEST,
    REMOVE_GROUP_MEMBER,
    UPDATE_GROUP_MEMBER_ROLE,
    TRANSFER_GROUP_OWNERSHIP,
    GROUP_PAGE_INIT_COURSE_TAB,
    GROUP_PAGE_ADD_GROUP_COURSE,
    GROUP_PAGE_ADD_GROUP_COURSE_DONE,
    GROUP_PAGE_DELETE_GROUP_COURSE,
    GROUP_PAGE_DELETE_GROUP_COURSE_DONE,
    GROUP_PAGE_INIT_COURSE_TAB_DONE,
    GROUP_PAGE_FETCH_COURSE_DETAIL_DONE,
    GROUP_PAGE_FETCH_COURSE_DETAIL,
    GROUP_PAGE_CLEAR_LAST_DELETE_COURSE_NAME,
    GROUP_PAGE_CLOSE_DELETE_COURSE_ERROR_DIALOG,
    FETCH_GROUP_CHALLENGES,
    UPDATE_GROUP_CHALLENGE,
    DELETE_GROUP_CHALLENGE,
    UPDATE_GROUP_CHALLENGE_UUID,
    UPDATE_GROUP_CHALLENGE_VIEW,
    FETCH_GROUP_CHALLENGE_LEADERBOARD,
    GROUP_PAGE_OPEN_REPORT_GROUP_PHOTO_DIALOG,
    GROUP_PAGE_CLOSE_REPORT_GROUP_PHOTO_DIALOG,
    GROUP_PAGE_SUBMIT_REPORT_GROUP_PHOTO,
    GROUP_PAGE_SUBMIT_REPORT_GROUP_PHOTO_DONE,
    RESET_GROUP_SHOW_ERROR_ALERT,
    UPDATE_GROUP_PAGE_SHOW_ERROR_ALERT,
    RESET_GROUP_FEED_ANIMATE_STATE,
    UPLOAD_POST_IMAGE,
    REMOVE_POST_IMAGE,
    REMOVE_POST_IMAGES,
    UPDATE_POST_IMAGES,
    UPDATE_POST_IMAGES_LIMIT_ERROR,
    RESET_POST_IMAGES_UPLOAD_RETRY_HINT,
    DELETE_POST_IMAGE,
    RESET_GROUP_POST_ERROR,
    RESET_GROUP_ANNOUNCEMENT_ERROR,
    INITIALIZE_GROUP_SINGLE_PAGE,
    RESET_GROUP_COMMENT_FOCUS,
    REMOVE_IMAGE_FROM_GROUP_POST,
    REMOVE_IMAGE_FROM_GROUP_POST_END,
    REMOVE_IMAGE_FROM_GROUP_POST_START,
    GROUP_PAGE_UPDATE_GROUP_SETTING,
    GROUP_PAGE_RESET_SHOW_CHANGES_SAVED,
    REMOVE_IMAGE_FROM_GROUP_ACTIVITY_FEED,
    GROUP_PAGE_SET_INVITE_ERROR_DIALOG_STATE,
    GROUP_PAGE_SET_LIMIT_ERROR_DIALOG
} from './ActionTypes';

import './groupPageActionsTypeDefs';

/**
 * group page: fetch single group
 * @param {{ groupId: number; viewerSocialProfile: object; viewerUserPreferences: object; viewerUserBiometrics: object }} payload
 * @returns
 */
export const fetchGroup = ({ groupId, viewerSocialProfile, viewerUserPreferences, viewerUserBiometrics }) => ({
    type: FETCH_GROUP,
    groupId,
    viewerSocialProfile,
    viewerUserPreferences,
    viewerUserBiometrics
});

/**
 * group page: fetch single group success
 * @param {TFetchGroupSuccessPayload} payload
 * @returns
 */
export const fetchGroupSuccess = ({
    group,
    groupMembers,
    groupAnnouncement,
    groupCourses,
    groupUserConnections,
    groupMemberRequest,
    groupInvitation
}) => ({
    type: FETCH_GROUP_SUCCESS,
    group,
    groupMembers,
    groupAnnouncement,
    groupCourses,
    groupUserConnections,
    groupMemberRequest,
    groupInvitation
});

export const fetchGroupFail = ({ isGroupPrivate, isGroupDeleted }) => ({
    type: FETCH_GROUP_FAIL,
    isGroupPrivate,
    isGroupDeleted
});

export const setGroupPageTab = (tab) => ({
    type: SET_GROUP_PAGE_TAB,
    tab
});

export const setGroupPageFeedTab = (feedTab) => ({
    type: SET_GROUP_PAGE_FEED_TAB,
    feedTab
});

export const saveGroupAnnouncement = ({ text }) => ({
    type: SAVE_GROUP_ANNOUNCEMENT,
    text
});

export const saveGroupAnnouncementSuccess = ({ groupAnnouncement }) => ({
    type: SAVE_GROUP_ANNOUNCEMENT_SUCCESS,
    groupAnnouncement
});

export const saveGroupAnnouncementFailed = () => ({
    type: SAVE_GROUP_ANNOUNCEMENT_FAILED
});

export const saveGroupPost = ({ text }) => ({
    type: SAVE_GROUP_POST,
    text
});

export const saveGroupPostSuccess = ({ newPost }) => ({
    type: SAVE_GROUP_POST_SUCCESS,
    newPost
});

export const saveGroupPostFailed = () => ({
    type: SAVE_GROUP_POST_FAILED
});

export const deleteGroupPost = ({ postUuid }) => ({
    type: DELETE_GROUP_POST,
    postUuid
});

export const deleteGroupPostSuccess = ({ postUuid }) => ({
    type: DELETE_GROUP_POST_SUCCESS,
    postUuid
});

export const deleteGroupPostFailed = ({ postUuid }) => ({
    type: DELETE_GROUP_POST_FAILED,
    postUuid
});

/**
 * remove image in group post. (not api related)
 * @param {{ postUuid: string; imageUuid: string }} payload
 * @returns
 */
export const removeImageFromGroupPost = ({ postUuid, imageUuid }) => ({
    type: REMOVE_IMAGE_FROM_GROUP_POST,
    postUuid,
    imageUuid
});

/**
 * remove image in group post. (not api related)
 * @param {{ postUuid: string; imageUuid: string }} payload
 * @returns
 */
export const removeImageFromGroupPostStart = ({ postUuid, imageUuid }) => ({
    type: REMOVE_IMAGE_FROM_GROUP_POST_START,
    postUuid,
    imageUuid
});

/**
 * check if post need to be remove from list after remove image
 * @param {{ postUuid: string }} payload
 * @returns
 */
export const removeImageFromGroupPostEnd = ({ postUuid }) => ({
    type: REMOVE_IMAGE_FROM_GROUP_POST_END,
    postUuid
});

/**
 * remove image in activity feed. (not api related)
 * @param {{ activityId: any; imageUuid: string }} payload
 * @returns
 */
export const removeImageFromGroupActivityFeed = ({ activityId, imageUuid }) => ({
    type: REMOVE_IMAGE_FROM_GROUP_ACTIVITY_FEED,
    activityId,
    imageUuid
});

export const deleteGroupAnnouncement = () => ({
    type: DELETE_GROUP_ANNOUNCEMENT
});

export const deleteGroupAnnouncementSuccess = () => ({
    type: DELETE_GROUP_ANNOUNCEMENT_SUCCESS
});

export const deleteGroupAnnouncementFailed = () => ({
    type: DELETE_GROUP_ANNOUNCEMENT_FAILED
});

export const fetchGroupPosts = () => ({
    type: FETCH_GROUP_POSTS
});

export const fetchGroupPostsSuccess = ({ posts, hasMore, cursor }) => ({
    type: FETCH_GROUP_POSTS_SUCCESS,
    posts,
    hasMore,
    cursor
});

export const fetchGroupPostsFailed = () => ({
    type: FETCH_GROUP_POSTS_FAILED
});

export const fetchGroupPost = ({ groupId, postUuid }) => ({
    type: FETCH_GROUP_POST,
    groupId,
    postUuid
});

export const fetchGroupComments = ({ resourceType, resourceId }) => ({
    type: FETCH_GROUP_COMMENTS,
    resourceType,
    resourceId
});

export const fetchGroupCommentsSuccess = ({ resourceType, resourceId, comments, hasMore }) => ({
    type: FETCH_GROUP_COMMENTS_SUCCESS,
    resourceType,
    resourceId,
    comments,
    hasMore
});

export const fetchGroupCommentsFailed = ({ resourceType, resourceId }) => ({
    type: FETCH_GROUP_COMMENTS_FAILED,
    resourceType,
    resourceId
});

export const saveGroupComment = ({ resourceType, resourceId, text }) => ({
    type: SAVE_GROUP_COMMENT,
    resourceType,
    resourceId,
    text
});

export const editGroupComment = ({ resourceType, resourceId, data, conversationUuid, conversationCommentUuid }) => ({
    type: EDIT_GROUP_COMMENT,
    resourceType,
    resourceId,
    data,
    conversationUuid,
    conversationCommentUuid
});

/**
 * @param {{ resourceType: string; resourceId:string; newComment: TConversationCommentDTO }} payload
 * @returns
 */
export const saveGroupCommentSuccess = ({ resourceType, resourceId, newComment }) => ({
    type: SAVE_GROUP_COMMENT_SUCCESS,
    resourceType,
    resourceId,
    newComment
});

export const saveGroupCommentFailed = ({ resourceType, resourceId, errorReachLimit = false }) => ({
    type: SAVE_GROUP_COMMENT_FAILED,
    resourceType,
    resourceId,
    errorReachLimit
});

/**
 * @param {{ resourceType:string; resourceId:string; comment: TConversationCommentDTO }} payload
 * @returns
 */
export const deleteGroupComment = ({ resourceType, resourceId, comment }) => ({
    type: DELETE_GROUP_COMMENT,
    resourceType,
    resourceId,
    comment
});

/**
 * @param {{ resourceType:string; resourceId:string; comment: TConversationCommentDTO }} payload
 * @returns
 */
export const deleteGroupCommentSuccess = ({ resourceType, resourceId, comment }) => ({
    type: DELETE_GROUP_COMMENT_SUCCESS,
    resourceType,
    resourceId,
    comment
});

/**
 * @param {{ resourceType:string; resourceId:string; comment: TConversationCommentDTO }} payload
 * @returns
 */
export const deleteGroupCommentFailed = ({ resourceType, resourceId, comment }) => ({
    type: DELETE_GROUP_COMMENT_FAILED,
    resourceType,
    resourceId,
    comment
});

/**
 * @param {{ deleteType: 'post' | 'comment' | 'course' | 'group' | 'postImage' ; postUuid:string; course: any; postImage: any }} payload
 * @returns
 */
export const openDeleteConfirmDialog = ({ deleteType, postUuid, course, postImage }) => ({
    type: OPEN_DELETE_CONFIRM_DIALOG,
    deleteType,
    postUuid,
    course,
    postImage
});

export const closeDeleteConfirmDialog = () => ({
    type: CLOSE_DELETE_CONFIRM_DIALOG
});

export const confirmDeleteConfirmDialog = () => ({
    type: CONFIRM_DELETE_CONFIRM_DIALOG
});

export const fetchGroupConversationLikers = ({ resourceType, resourceId }) => ({
    type: FETCH_GROUP_CONVERSATION_LIKERS,
    resourceType,
    resourceId
});

export const fetchGroupConversationLikersDone = ({ resourceType, resourceId, likers = null, error = false }) => ({
    type: FETCH_GROUP_CONVERSATION_LIKERS_DONE,
    resourceType,
    resourceId,
    likers,
    error
});

export const updateGroupConversationLike = ({ resourceType, resourceId, like, conversationUuid, likerInfo }) => ({
    type: UPDATE_GROUP_CONVERSATION_LIKE,
    resourceType,
    resourceId,
    like,
    conversationUuid,
    likerInfo
});

export const updateGroupConversationLikeStart = ({ resourceType, resourceId }) => ({
    type: UPDATE_GROUP_CONVERSATION_LIKE_START,
    resourceType,
    resourceId
});

export const updateGroupConversationLikeDone = ({
    resourceType,
    resourceId,
    like = null,
    error = false,
    likerInfo = {},
    conversationUuid = null,
    errorReachLimit = null,
    conversationLikeDto = null
}) => ({
    type: UPDATE_GROUP_CONVERSATION_LIKE_DONE,
    resourceType,
    resourceId,
    like,
    error,
    likerInfo,
    conversationUuid,
    errorReachLimit,
    conversationLikeDto
});

export const fetchGroupCommentLikers = ({ resourceType, resourceId, conversationCommentUuid }) => ({
    type: FETCH_GROUP_COMMENT_LIKERS,
    resourceType,
    resourceId,
    conversationCommentUuid
});

export const fetchGroupCommentLikersDone = ({
    resourceType,
    resourceId,
    conversationCommentUuid,
    likers = null,
    error = false
}) => ({
    type: FETCH_GROUP_COMMENT_LIKERS_DONE,
    resourceType,
    resourceId,
    conversationCommentUuid,
    likers,
    error
});

export const updateGroupCommentLike = ({ resourceType, resourceId, conversationCommentUuid, like }) => ({
    type: UPDATE_GROUP_COMMENT_LIKE,
    resourceType,
    resourceId,
    conversationCommentUuid,
    like
});

export const updateGroupCommentLikeStart = ({ resourceType, resourceId, conversationCommentUuid }) => ({
    type: UPDATE_GROUP_COMMENT_LIKE_START,
    resourceType,
    resourceId,
    conversationCommentUuid
});

export const updateGroupCommentLikeDone = ({
    resourceType,
    resourceId,
    conversationCommentUuid,
    like = null,
    likeDto = null,
    error = false,
    errorReachLimit = null
}) => ({
    type: UPDATE_GROUP_COMMENT_LIKE_DONE,
    resourceType,
    resourceId,
    conversationCommentUuid,
    like,
    likeDto,
    error,
    errorReachLimit
});

export const confirmLeaveGroup = () => ({
    type: CONFIRM_LEAVE_GROUP
});

export const initGroupLeaderboard = () => ({
    type: INIT_GROUP_LEADERBOARD
});

export const setGroupLeaderboardType = ({ leaderboardType }) => ({
    type: SET_GROUP_LEADERBOARD_TYPE,
    leaderboardType
});

export const setGroupLeaderboardViewPrevious = ({ viewPrevious }) => ({
    type: SET_GROUP_LEADERBOARD_VIEW_PREVIOUS,
    viewPrevious
});

export const fetchGroupLeaderboard = () => ({
    type: FETCH_GROUP_LEADERBOARD
});

/**
 *
 * @param {{ list: TUserInfoMetricCube[] }} payload
 * @returns
 */
export const fetchGroupLeaderboardSuccess = ({ list }) => ({
    type: FETCH_GROUP_LEADERBOARD_SUCCESS,
    list
});

export const fetchGroupLeaderboardFailed = () => ({
    type: FETCH_GROUP_LEADERBOARD_FAILED
});

export const fetchGroupAllFeeds = () => ({
    type: FETCH_GROUP_ALL_FEEDS
});

export const fetchGroupActivityFeeds = () => ({
    type: FETCH_GROUP_ACTIVITY_FEEDS
});

export const fetchGroupActivityFeedsSuccess = ({ list, hasMore, cursor, daysLimit }) => ({
    type: FETCH_GROUP_ACTIVITY_FEEDS_SUCCESS,
    list,
    hasMore,
    cursor,
    daysLimit
});

export const fetchGroupActivityFeedsFailed = () => ({
    type: FETCH_GROUP_ACTIVITY_FEEDS_FAILED
});

export const fetchGroupActivityFeed = ({ groupId, activityId }) => ({
    type: FETCH_GROUP_ACTIVITY_FEED,
    groupId,
    activityId
});

export const groupPageJoinGroup = () => ({
    type: GROUP_PAGE_JOIN_GROUP
});

export const requestJoinGroup = () => ({
    type: GROUP_PAGE_REQUEST_JOIN_GROUP
});

export const groupPageCancelRequestJoinGroup = () => ({
    type: GROUP_PAGE_CANCEL_REQUEST_JOIN_GROUP
});

export const groupPageAcceptInvitation = () => ({
    type: GROUP_PAGE_ACCEPT_INVITATION
});

export const updateGroupMemberRequest = (groupMemberRequest) => ({
    type: UPDATE_GROUP_MEMBER_REQUEST,
    groupMemberRequest
});

export const updateGroupMembers = (groupMembers) => ({
    type: UPDATE_GROUP_MEMBERS,
    groupMembers
});

export const sortGroupMembers = () => ({
    type: SORT_GROUP_MEMBERS
});

export const updateGroupInvites = (groupInvites, groupRejectedInvites) => ({
    type: UPDATE_GROUP_INVITES,
    groupInvites,
    groupRejectedInvites
});

/**
 * update list of group user connection
 * @param {any[]} groupUserConnections
 * @returns
 */
export const updateGroupUserConnections = (groupUserConnections) => ({
    type: UPDATE_GROUP_USER_CONNECTIONS,
    groupUserConnections
});

/**
 * update specific group user connection
 * @param {{ connectionRequestId?: number; connectionRequestorId?: number; connectionStatus: number; userProfileId: number }} groupUserConnection
 * @returns
 */
export const updateGroupUserConnection = (groupUserConnection) => ({
    type: UPDATE_GROUP_USER_CONNECTION,
    groupUserConnection
});

/**
 * group page search user
 * @param {{ keyword?: string; reset?: boolean }} payload
 * @returns
 */
export const searchUser = ({ keyword, reset = false }) => ({
    type: GROUP_PAGE_SEARCH_USER,
    keyword,
    reset
});

/**
 * group page search user
 * @param {{ reset?: boolean; list?: any[]; hasMore?: boolean; nextCursor?: number; error: boolean }} payload
 * @returns
 */
export const searchUserDone = ({ reset = false, list = [], hasMore = false, nextCursor, error }) => ({
    type: GROUP_PAGE_SEARCH_USER_DONE,
    reset,
    list,
    hasMore,
    nextCursor,
    error
});

/**
 * update search user list connection status
 * @param {TConnectionStatus} connectionStatus
 */
export const updateSearchUserConnectionStatus = (connectionStatus) => ({
    type: UPDATE_GROUP_SEARCH_USER_CONNECTION_STATUS,
    connectionStatus
});

export const unblockUser = ({ connection }) => ({
    type: GROUP_PAGE_UNBLOCK_USER,
    connection
});

export const unblockUserDone = ({ connection }) => ({
    type: GROUP_PAGE_UNBLOCK_USER_DONE,
    connection
});

export const cancelInviteUser = ({ connection }) => ({
    type: GROUP_PAGE_CANCEL_INVITE_USER,
    connection
});

export const cancelInviteUserDone = ({ connection, error = false }) => ({
    type: GROUP_PAGE_CANCEL_INVITE_USER_DONE,
    connection,
    error
});

export const inviteUser = ({ connection }) => ({
    type: GROUP_PAGE_INVITE_USER,
    connection
});

export const inviteUserDone = ({ connection, error = false, newInvite = null }) => ({
    type: GROUP_PAGE_INVITE_USER_DONE,
    connection,
    error,
    newInvite
});

/**
 *
 * @param {{
 *  open: boolean;
 *  errorType: 'limit' | 'decline';
 *  inviteDTO?: TGroupInviteDTO
 * }} payload
 * @returns
 */
export const setInviteErrorDialogState = ({ open, errorType, inviteDTO = null }) => ({
    type: GROUP_PAGE_SET_INVITE_ERROR_DIALOG_STATE,
    open,
    errorType,
    inviteDTO
});

export const removeGroupMember = ({ userProfileId }) => ({
    type: REMOVE_GROUP_MEMBER,
    userProfileId
});

export const updateGroupMemberRole = ({ userProfileId, groupRole }) => ({
    type: UPDATE_GROUP_MEMBER_ROLE,
    userProfileId,
    groupRole
});

export const transferGroupOwnership = ({ userProfileId }) => ({
    type: TRANSFER_GROUP_OWNERSHIP,
    userProfileId
});

export const initCourseTab = () => ({
    type: GROUP_PAGE_INIT_COURSE_TAB
});

export const initCourseTabDone = ({ error = false, userCourses, groupCourses }) => ({
    type: GROUP_PAGE_INIT_COURSE_TAB_DONE,
    error,
    userCourses,
    groupCourses
});

export const fetchGroupCourseDetail = ({ groupCourseId }) => ({
    type: GROUP_PAGE_FETCH_COURSE_DETAIL,
    groupCourseId
});

export const fetchGroupCourseDetailDone = ({ error = false, groupCourseId, groupCourseDetail }) => ({
    type: GROUP_PAGE_FETCH_COURSE_DETAIL_DONE,
    error,
    groupCourseId,
    groupCourseDetail
});

export const addGroupCourse = (userCourseId) => ({
    type: GROUP_PAGE_ADD_GROUP_COURSE,
    userCourseId
});

export const addGroupCourseDone = (newCourse) => ({
    type: GROUP_PAGE_ADD_GROUP_COURSE_DONE,
    newCourse
});

export const deleteGroupCourse = (groupCourseId) => ({
    type: GROUP_PAGE_DELETE_GROUP_COURSE,
    groupCourseId
});

export const deleteGroupCourseDone = ({ error = false, groupCourseId }) => ({
    type: GROUP_PAGE_DELETE_GROUP_COURSE_DONE,
    error,
    groupCourseId
});

export const clearLastDeleteCourseName = () => ({
    type: GROUP_PAGE_CLEAR_LAST_DELETE_COURSE_NAME
});

export const clearDeleteCourseErrorDialog = () => ({
    type: GROUP_PAGE_CLOSE_DELETE_COURSE_ERROR_DIALOG
});

export const fetchGroupChallenges = () => ({
    type: FETCH_GROUP_CHALLENGES
});

export const updateGroupChallenge = (challenge) => ({
    type: UPDATE_GROUP_CHALLENGE,
    challenge
});

export const deleteGroupChallenge = (uuid) => ({
    type: DELETE_GROUP_CHALLENGE,
    uuid
});

export const updateGroupChallengeUuid = (uuid) => ({
    type: UPDATE_GROUP_CHALLENGE_UUID,
    uuid
});

export const updateGroupChallengeView = (view) => ({
    type: UPDATE_GROUP_CHALLENGE_VIEW,
    view
});

export const fetchGroupChallengeLeaderboard = () => ({
    type: FETCH_GROUP_CHALLENGE_LEADERBOARD
});

export const openReportGroupPhotoDialog = (payload = {}) => ({
    type: GROUP_PAGE_OPEN_REPORT_GROUP_PHOTO_DIALOG,
    ...payload
});

export const closeReportGroupPhotoDialog = ({ reviewStatus = '', isGroupProfile = true }) => ({
    type: GROUP_PAGE_CLOSE_REPORT_GROUP_PHOTO_DIALOG,
    reviewStatus,
    isGroupProfile
});

export const submitReportGroupPhoto = ({ flagReason, note }) => ({
    type: GROUP_PAGE_SUBMIT_REPORT_GROUP_PHOTO,
    flagReason,
    note
});

export const submitReportGroupPhotoDone = ({ error = false, reviewStatus }) => ({
    type: GROUP_PAGE_SUBMIT_REPORT_GROUP_PHOTO_DONE,
    error,
    reviewStatus
});

export const resetGroupShowErrorAlert = () => ({
    type: RESET_GROUP_SHOW_ERROR_ALERT
});

export const updateGroupPageShowErrorAlert = ({ showAlert }) => ({
    type: UPDATE_GROUP_PAGE_SHOW_ERROR_ALERT,
    showAlert
});

export const resetGroupFeedAnimateState = () => ({
    type: RESET_GROUP_FEED_ANIMATE_STATE
});

export const uploadPostImage = ({ file = null, imageB64 = null, retryIndex = null, callback = () => {} }) => ({
    type: UPLOAD_POST_IMAGE,
    file,
    imageB64,
    retryIndex,
    callback
});

export const removePostImage = ({ index }) => ({
    type: REMOVE_POST_IMAGE,
    index
});

export const removePostImages = () => ({
    type: REMOVE_POST_IMAGES
});

export const updatePostImages = ({ images }) => ({
    type: UPDATE_POST_IMAGES,
    images
});

export const updatePostImagesLimitError = ({ error }) => ({
    type: UPDATE_POST_IMAGES_LIMIT_ERROR,
    error
});

export const resetPostImagesUploadRetryHint = () => ({
    type: RESET_POST_IMAGES_UPLOAD_RETRY_HINT
});

export const deletePostImage = ({ newsPostUuid, newsPostHasImageId }) => ({
    type: DELETE_POST_IMAGE,
    newsPostUuid,
    newsPostHasImageId
});

export const resetGroupPostError = () => ({
    type: RESET_GROUP_POST_ERROR
});

export const resetGroupAnnouncementError = () => ({
    type: RESET_GROUP_ANNOUNCEMENT_ERROR
});

export const initialzeGroupSinglePage = ({
    groupId,
    activityId = null,
    postUuid = null,
    commentUuid = null,
    viewerSocialProfile
}) => ({
    type: INITIALIZE_GROUP_SINGLE_PAGE,
    groupId,
    activityId,
    postUuid,
    commentUuid,
    viewerSocialProfile
});

export const resetGroupCommentFocus = () => ({
    type: RESET_GROUP_COMMENT_FOCUS
});

export const updateGroupSetting = ({ group }) => ({
    type: GROUP_PAGE_UPDATE_GROUP_SETTING,
    group
});

export const resetShowChangesSaved = () => ({
    type: GROUP_PAGE_RESET_SHOW_CHANGES_SAVED
});

export const setGroupPageLimitErrorDialog = ({ open, errorType }) => ({
    type: GROUP_PAGE_SET_LIMIT_ERROR_DIALOG,
    open,
    errorType
});

/**
 * group page: reset
 * @returns
 */
export const resetGroupPage = () => ({
    type: RESET_GROUP_PAGE
});
